/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../glyph/glyph_icon';
import '../../../bankingfindata/transaction';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "categories": {
                "nested": {
                  "CategoryItem": {
                    "fields": {
                      "categoryId": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "translatedLabel": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "icon": {
                        "type": ".squareup.bbfrontend.common.glyph.GlyphIcon",
                        "id": 3,
                        "rule": "optional"
                      },
                      "darkModeColors": {
                        "type": ".squareup.bbfrontend.common.categories.CategoryItem.Colors",
                        "id": 4,
                        "rule": "optional"
                      },
                      "lightModeColors": {
                        "type": ".squareup.bbfrontend.common.categories.CategoryItem.Colors",
                        "id": 5,
                        "rule": "optional"
                      },
                      "rank": {
                        "type": "int32",
                        "id": 6,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "Colors": {
                        "fields": {
                          "iconBackgroundHexColor": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "iconTintHexColor": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "checkmarkHexColor": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  },
                  "TransactionCategory": {
                    "fields": {
                      "accountIdentifier": {
                        "type": ".squareup.bankingfindata.transaction.AccountUniqueIdentifier",
                        "id": 1,
                        "rule": "optional"
                      },
                      "transactionToken": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "categoryId": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "findataAccountIdentifier": {
                        "type": "bytes",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.CategoryItem && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.CategoryItem?.nested?.Colors && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.categories?.nested?.TransactionCategory) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CategoryItem @ squareup/bbfrontend/common/categories/categories.proto at 13:1
 */
export const CategoryItem = $root.lookupType('squareup.bbfrontend.common.categories.CategoryItem');
fixType(CategoryItem, {
  categoryId: {
    notEmpty: true
  },
  translatedLabel: {
    notEmpty: true
  },
  icon: {
    required: true
  },
  darkModeColors: {
    required: true
  },
  lightModeColors: {
    required: true
  },
  rank: {
    required: true
  }
});
Builder.createAndAttachToType(CategoryItem);
/**
 * SOURCE Colors @ squareup/bbfrontend/common/categories/categories.proto at 14:3
 */
CategoryItem.Colors = $root.lookupType('squareup.bbfrontend.common.categories.CategoryItem.Colors');
fixType(CategoryItem.Colors, {
  iconBackgroundHexColor: {
    notEmpty: true
  },
  iconTintHexColor: {
    notEmpty: true
  },
  checkmarkHexColor: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CategoryItem.Colors);
/**
 * SOURCE TransactionCategory @ squareup/bbfrontend/common/categories/categories.proto at 31:1
 */
export const TransactionCategory = $root.lookupType('squareup.bbfrontend.common.categories.TransactionCategory');
fixType(TransactionCategory, {
  transactionToken: {
    notEmpty: true
  },
  categoryId: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(TransactionCategory);